import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"color":_vm.color,"top":_vm.top,"right":_vm.right,"dark":"","multi-line":"","absolute":"","timeout":_vm.timeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('div',{style:(`color:${_vm.colorFI};`)},[_vm._v("\n    "+_vm._s(this.mensagem)+"\n  ")]),_c(VIcon,{attrs:{"color":_vm.colorFI,"size":"16"},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("close\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }